import React, { useEffect, useState } from "react";
import { MakeAxiosRequest } from "../../../utils/handler";
import Loader from "../../../Components/loader/Loader";
import { ModalContentWithData, ModalHeader } from "../DetailsModal";
import EditAccountPermission from "./EditAccountPermission";
import { SwalConfirm } from "../../../Components/SwalFns";
import NoData from "./NoData";

function AccountPermission({
  proxyKey,
  changeView,
  handleBack,
  isLoading,
  setIsLoading,
}) {
  const [response, setResponse] = useState({});
  const [editPermissionKey, setEditPermissionKey] = useState("");
  const [editModalShow, setEditModalShow] = useState(false);

  const fetchData = async () => {
    try {
      setIsLoading({ modal: true, content: true });
      const res = await MakeAxiosRequest(
        "post",
        "relationaccountpermissiondetails",
        {
          user_proxy_key: proxyKey,
        }
      );
      if (res.name !== "CanceledError" && res.status == 1) {
        setResponse((prevResponse) => ({
          ...prevResponse,
          ...res.data,
        }));
        // console.log(res.data);
        setIsLoading({ modal: false, content: false });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsLoading({ modal: false, content: false });
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const deleteAcess = async (key) => {
    await SwalConfirm({
      title: "Remove Account Access",
      subText: `Are you sure you want to continue?`,
      actionUrl: "removerelationpermission",
      actionParams: { user_proxy_permission_key: key },
      // successMsg: `Deleted successfully`,
      successFn: fetchData,
      errorMsg: "An error occurred.",
    });
  };

  const triggerMenu = (type, key) => {
    switch (type) {
      case "edit_permission":
        // console.log(key);
        setEditPermissionKey(key);
        setEditModalShow(true);
        break;
      case "remove_permission":
        deleteAcess(key);
        break;
    }
  };

  const closeEditModal = () => {
    setEditPermissionKey("");
    setEditModalShow(false);
  };

  if (isLoading.modal) return <Loader />;
  return (
    <>
      <ModalHeader title="Account Permissions" handleBack={handleBack} />
      <ModalContentWithData proxydata={response.proxydata}>
        {response.accountAccess?.length > 0 ? (
          <div className="col-12 mt-4">
            <p>Account Access</p>
            <div>
              {response.accountAccess?.map((user, index) => (
                <div className="row act-Access" key={index}>
                  <div className="col-11">
                    <div className="d-flex align-items-center justify-content-center justify-content-md-start flex-wrap text-center">
                      <div className="profile-img">
                        <img
                          src={user?.image_path}
                          style={{ width: "35px", height: "35px" }}
                        />
                      </div>
                      <div className="mt-2 mt-md-0 ms-lg-1 text-lg-start rltnshp-txt">
                        <p className="mb-1">{user?.name}</p>
                        {user?.proxy_relation && (
                          <small className="d-block">
                            {user?.proxy_relation}
                          </small>
                        )}
                      </div>

                    </div>
                  </div>
                  <div className="col-1 align-items-center d-flex">
                    {user.menuArray?.length > 0 && (
                      <div>
                        <div className="btn-group option-btn">
                          <a href="javascript:void(0)"className="btn dropdown-toggle"data-bs-toggle="dropdown"data-bs-display="static"aria-expanded="false">
                           <span className="material-symbols-outlined">more_vert</span>
                          </a>
                          <ul className="dropdown-menu dropdown-menu-end">
                            {user.menuArray
                              .filter((menu) => menu.is_show === 1)
                              .map((menu, i) => (
                                <li
                                  key={i}
                                  onClick={() =>
                                    triggerMenu(
                                      menu.type,
                                      user.user_proxy_permission_key
                                    )
                                  }
                                >
                                  <a
                                    className="dropdown-item"
                                    href="javascript:void(0)"
                                  >
                                    {menu.label}
                                  </a>
                                </li>
                              ))}
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <NoData />
        )}
      </ModalContentWithData>
      <div className="row justify-content-end mt-4">
        <div className="col-md-4">
          <button
            type="button"
            className="btn btn-primary rounded-pill w-100 my-2 p-2"
            onClick={changeView}
          >
            Add Permissions
          </button>
        </div>
      </div>
      <EditAccountPermission
        showModal={editModalShow}
        closeModal={closeEditModal}
        userKey={editPermissionKey}
      />
    </>
  );
}

export default AccountPermission;
